import cookies from 'js-cookie';

export const setBetaFeaturesCookieOn = (): void => {
  cookies.set('development-beta-features', 'on');
};
